/**
 * Welcome Screen Component
 * 
 * Initial screen shown when app loads, allowing users to upload a project file.
 * Supports both click-to-upload and drag-and-drop functionality.
 */

import React from 'react';
import './WelcomeScreen.css';
import { UploadButton } from './UploadButton';

/**
 * Welcome screen with file upload options
 * 
 * @param {object} props - Component props
 * @param {function} props.onUploadClick - Handler for upload button click
 * @param {function} props.onFileChange - Handler for file selection
 * @param {function} props.onFileDrop - Handler for drag-and-drop
 * @param {React.RefObject} props.inputRef - Ref for hidden file input
 */
export function WelcomeScreen({ onUploadClick, onFileChange, onFileDrop, inputRef }) {
  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file) {
      onFileDrop(file);
    }
  };
  
  const handleDrag = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  
  return (
    <div 
      className="drop-area"
      onDrop={handleDrop}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
    >
      <UploadButton
        onUploadClick={onUploadClick}
        onFileChange={onFileChange}
        inputRef={inputRef}
      />
      <p style={{ textAlign: 'center' }}>
        or
        <br />
        Drop .json file here
      </p>
    </div>
  );
}


